import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  Dispatch,
  Store,
} from 'redux';
import { withExtraArgument } from 'redux-thunk';
import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
  TypedUseSelectorHook,
} from 'react-redux';
import registrationApi from '../api/DriverRegistrationApi';
import documentsApi from '../api/DocumentsApi';
import eventLogApi from '../api/EventLogApi';
import { formReducer } from './form/formReducers';
import { notificationsReducer } from './notification/notificationsReducer';
import { experimentReducer } from './experiment/experimentReducer';
import { IAppState, ThunkMiddlware } from './types';
import { mixpanelReducer } from './mixpanel/mixpanelReducer';
import { authReducer } from './auth/authReducer';
import { autosaveReducer } from './autosave/autosaveReducer';
import { localizationReducer } from './localization/localizationReducer';
import { verificationReducer } from './verification/verificationReducer';
import { riderUserSignupReducer } from './rider_user_signup/riderUserSignupReducer';
import { settingsReducer } from './settings/settingsReducer';

const rootReducer = combineReducers({
  form: formReducer,
  notifications: notificationsReducer,
  experiments: experimentReducer,
  mixpanel: mixpanelReducer,
  auth: authReducer,
  autosave: autosaveReducer,
  localization: localizationReducer,
  verification: verificationReducer,
  riderUserSignup: riderUserSignupReducer,
  settings: settingsReducer,
});

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewareDeps: ThunkMiddlware = {
  documentsApi,
  registrationApi,
  eventLogApi,
};
const thunkMiddleware = withExtraArgument(middlewareDeps);
const enhancer = composeEnhancers(applyMiddleware(thunkMiddleware));
export const useSelector: TypedUseSelectorHook<IAppState> = useReduxSelector;
const useTypedReduxDispatch = useReduxDispatch.withTypes<Dispatch<any>>();
export const useDispatch = useTypedReduxDispatch;

export const store = createStore(rootReducer, enhancer) as Store<
  IAppState,
  any
>;
